export default __webpack_public_path__ + "static/media/26.f81d1fe5.wav";